import axios from "axios";

const state = {
  myStatsWeeklyScores: {},
  myStatsWeeklyRank: [],
  myStatsWeeklyRankMaxRank: null,
};

const getters = {
  myStatsWeeklyScores(state) { return state.myStatsWeeklyScores },
  myStatsWeeklyRank(state) { return state.myStatsWeeklyRank },
  myStatsWeeklyRankMaxRank(state) { return state.myStatsWeeklyRankMaxRank },
};

const actions = {
  getMyStatsWeeklyScores({ commit, getters }) {
    if (!getters.myStatsWeeklyScores.length) {
      axios.get(process.env.VUE_APP_API_URL + 'weekly_scores/get_my_stats_weekly_scores')
      .then(response => {
        commit('SET_MY_STATS_WEEKLY_SCORES', response.data.data);
      })
    }
  },
  getMyStatsWeeklyRank({ commit, getters }) {
    if (!getters.myStatsWeeklyRank.length) {
      axios.get(process.env.VUE_APP_API_URL + 'weekly_scores/get_my_stats_weekly_ranks')
        .then(response => {
          commit('SET_MY_STATS_LEAGUE_POS', response.data.data.league_positions);
          commit('SET_MY_STATS_LEAGUE_POS_MAX_RANK', response.data.data.max_rank);
        })
    }
	}
};

const mutations = {
  SET_MY_STATS_WEEKLY_SCORES(state, data) { state.myStatsWeeklyScores = data },
  SET_MY_STATS_LEAGUE_POS(state, data) { state.myStatsWeeklyRank = data },
  SET_MY_STATS_LEAGUE_POS_MAX_RANK(state, rank) { state.myStatsWeeklyRankMaxRank = rank },
};


export default {
  state,
  getters,
  actions,
  mutations,
}
